module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_002.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_002.png
// module id = 2349
// module chunks = 5